import React from "react";


function Founders() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/9.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <div className="row">
            <div className="col-md-12">
                 <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>Founder Trustees</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                   <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/akg.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">A.K.G.NAIR</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/tm.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">T. MURALIDHARAN NAIR</p>
                            <p className="designation"></p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/kv.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">K.V.KARTHIKEYAN</p>
                            <p className="designation"></p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/akk.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">A.K.K.NAIR</p>
                            <p className="designation"></p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/trs.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">T.R.S.NAIR</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/mgs.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">M.G.S.MENON</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/kr.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">K.RAGHAVAN</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/cvb.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">C.V.BALAKRISHNA MENON</p>
                            <p className="designation"></p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/rk.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">RAJAN KADANNAPPILLY</p>
                            <p className="designation"></p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/kam.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">K.A.MENON</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/pvr.jpeg)', backgroundSize:'cover',backgroundPosition:'top'}}></div>
                            <p className="name">P.V.RAGHAVAN</p>
                            <p className="designation"></p>
                        </div>
                    </div>                     
                </div>
           </div>            
        </div>
        
        
      </div>
    </div>
  );
}

export default Founders;